// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider-module__container--2FsiT","bar":"Slider-module__bar--XSqIH"};